module.exports = __webpack_public_path__ + "img/billsafe.689225c2.png";